import React from 'react';

interface LocationIconProps {
    width?: number;
    height?: number;
    fill?: string;
}

const LocationIcon = ({ width = 16, height = 17, fill = '#B2B3B5' }: LocationIconProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_2348_51960)">
                <path
                    d="M8.05781 16.5C7.98336 16.5003 7.90958 16.4858 7.84082 16.4573C7.77206 16.4287 7.70968 16.3867 7.65737 16.3338L3.30537 11.9818C2.36425 11.0416 1.72312 9.84346 1.46309 8.53886C1.20307 7.23426 1.33583 5.88184 1.84458 4.65271C2.35333 3.42357 3.21522 2.37295 4.32119 1.63375C5.42717 0.894556 6.72755 0.5 8.05781 0.5C9.38807 0.5 10.6884 0.894556 11.7944 1.63375C12.9004 2.37295 13.7623 3.42357 14.271 4.65271C14.7798 5.88184 14.9126 7.23426 14.6525 8.53886C14.3925 9.84346 13.7514 11.0416 12.8102 11.9818L8.45825 16.3338C8.40594 16.3867 8.34356 16.4287 8.2748 16.4573C8.20604 16.4858 8.13226 16.5003 8.05781 16.5ZM8.05781 1.63824C6.95256 1.63902 5.87234 1.96735 4.95361 2.58176C4.03488 3.19617 3.31885 4.06909 2.896 5.09025C2.47314 6.11141 2.36243 7.23499 2.57784 8.31904C2.79325 9.40309 3.32512 10.399 4.10626 11.1809L8.05781 15.1324L12.0094 11.1809C12.7905 10.399 13.3224 9.40309 13.5378 8.31904C13.7532 7.23499 13.6425 6.11141 13.2196 5.09025C12.7968 4.06909 12.0807 3.19617 11.162 2.58176C10.2433 1.96735 9.16306 1.63902 8.05781 1.63824Z"
                    fill={fill}
                />
                <path
                    d="M8.05782 9.72232C7.49744 9.72232 6.94964 9.55615 6.4837 9.24482C6.01777 8.93349 5.65461 8.49098 5.44016 7.97326C5.22572 7.45554 5.16961 6.88585 5.27893 6.33624C5.38825 5.78663 5.6581 5.28178 6.05435 4.88553C6.4506 4.48928 6.95545 4.21943 7.50506 4.11011C8.05467 4.00078 8.62436 4.05689 9.14209 4.27134C9.65981 4.48579 10.1023 4.84894 10.4136 5.31488C10.725 5.78082 10.8911 6.32861 10.8911 6.88899C10.8911 7.64044 10.5926 8.36111 10.0613 8.89246C9.52993 9.42381 8.80926 9.72232 8.05782 9.72232ZM8.05782 5.189C7.72159 5.189 7.39291 5.2887 7.11335 5.4755C6.83379 5.6623 6.61589 5.9278 6.48723 6.23843C6.35856 6.54907 6.32489 6.89088 6.39049 7.22065C6.45608 7.55041 6.61799 7.85332 6.85574 8.09107C7.09349 8.32882 7.3964 8.49073 7.72616 8.55633C8.05593 8.62192 8.39774 8.58825 8.70838 8.45959C9.01901 8.33092 9.28452 8.11303 9.47131 7.83346C9.65811 7.5539 9.75781 7.22522 9.75781 6.88899C9.75781 6.43813 9.57871 6.00573 9.2599 5.68691C8.94109 5.3681 8.50868 5.189 8.05782 5.189Z"
                    fill={fill}
                />
            </g>
            <defs>
                <clipPath id="clip0_2348_51960">
                    <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default LocationIcon;
